
const logLevels = {
    TRACE: 0,
    DEBUG: 1,
    INFO: 2,
    WARN: 3,
    ERROR: 4,
    FATAL: 5,
}

const formatLogMessage = (logLevel, msg) => {
    const date = new Date().toISOString();
    const dateFormatted = date.substr(11, 12);
    return `${dateFormatted} | ${logLevel} | ${msg}`;
}

let minimalLevel = logLevels.DEBUG;

const logInternal = (logLevel, msg) => {
    if(logLevel < minimalLevel) return;

    const logLevelProps = Object.entries(logLevels);
    let textLevel = '';
    logLevelProps.forEach((entry) => {if(entry.value === logLevel){textLevel = entry.key}});
    if(logLevel === logLevel.ERROR || logLevel === logLevel.WARN || logLevel === logLevel.FATAL ){
        console.error(formatLogMessage(textLevel, msg));
    }
    else {
        console.log(formatLogMessage(textLevel, msg));
    }
    
}

const log = {
    setMinimulLevel: (level) => {
        minimalLevel = level;
    },
    trace: (msg) => {
        logInternal(logLevels.TRACE, msg);
    },
    debug: (msg) => {
        logInternal(logLevels.DEBUG, msg);
    },
    info: (msg) => {
        logInternal(logLevels.INFO, msg);
    },
    warn: (msg) => {
        logInternal(logLevels.WARN, msg);
    },
    error: (msg) => {
        logInternal(logLevels.ERROR, msg);
    },
    fatal: (msg) => {
        logInternal(logLevels.FATAL, msg);
    },
}

export default log;